import { render } from "./ActionButton.vue?vue&type=template&id=6081f7ea&scoped=true"
import script from "./ActionButton.vue?vue&type=script&lang=js"
export * from "./ActionButton.vue?vue&type=script&lang=js"

import "./ActionButton.vue?vue&type=style&index=0&id=6081f7ea&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-6081f7ea"

export default script